// extracted by mini-css-extract-plugin
export default {"loading":"OrderItemLoading-module_loading__Mx39Z","itemBlur":"OrderItemLoading-module_itemBlur__J2aH9"};